/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClusterUserSchema
 */
export interface ClusterUserSchema {
    /**
     * 
     * @type {number}
     * @memberof ClusterUserSchema
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ClusterUserSchema
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof ClusterUserSchema
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ClusterUserSchema
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof ClusterUserSchema
     */
    preferredName: string;
}

/**
 * Check if a given object implements the ClusterUserSchema interface.
 */
export function instanceOfClusterUserSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "fullName" in value;
    isInstance = isInstance && "preferredName" in value;

    return isInstance;
}

export function ClusterUserSchemaFromJSON(json: any): ClusterUserSchema {
    return ClusterUserSchemaFromJSONTyped(json, false);
}

export function ClusterUserSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClusterUserSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'username': json['username'],
        'email': json['email'],
        'fullName': json['full_name'],
        'preferredName': json['preferred_name'],
    };
}

export function ClusterUserSchemaToJSON(value?: ClusterUserSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'username': value.username,
        'email': value.email,
        'full_name': value.fullName,
        'preferred_name': value.preferredName,
    };
}

